import { eventBus } from '@spon/plugins';

function AutoplayVideos() {
	eventBus.on('play:video', ({ direction, id }) => {
		const $video = document.getElementById(id);
		if (direction === 'enter') {
			log('played video');
			if (!$video.playing) $video.play();
		} else {
			log('paused pause');
			if ($video.playing) $video.pause();
		}
	});
}

export default AutoplayVideos;


if (module.hot) {module.hot.accept(function(err) {
if (err) {
console.error(err);
}
});
}
